module.exports = __webpack_public_path__ + "img/icon_exchange_50people.cdd84ade.png";